var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnhexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0588 9.17969H6.66471V5.16455C6.66471 3.39355 8.1598 1.95312 9.99804 1.95312C11.8363 1.95312 13.3314 3.39355 13.3314 5.16455V7.03125H15.2922V5.16455C15.2922 2.31689 12.9172 0 9.99804 0C7.07892 0 4.70392 2.31689 4.70392 5.16455V9.17969H2.94118C1.31912 9.17969 0 10.4941 0 12.1094V22.0703C0 23.6855 1.31912 25 2.94118 25H17.0588C18.6804 25 20 23.6855 20 22.0703V12.1094C20 10.4941 18.6804 9.17969 17.0588 9.17969ZM14.1358 16.1724H12.6412V17.9585H14.1358V19.7451H12.6412V21.2339H10.8475V19.7451H9.05392V21.2339H7.26078V19.7451H5.76618V17.9585H7.26078V16.1724H5.76618V14.3857H7.26078V12.897H9.05392V14.3857H10.8475V12.897H12.6412V14.3857H14.1358V16.1724Z",
    fill: "#5196FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhexIcon);
export default __webpack_public_path__ + "static/media/unhex_icon.92bd9bfb3df70a2c197e30bf8c79df68.svg";
export { ForwardRef as ReactComponent };